<template>
    <div>
        <div class="item-img-mask" />
        <span class="mask-icon-selected">选中</span>
    </div>
</template>

<script>
export default {
    name: 'MaskChecked',
};
</script>

<style scoped>
.item-img-mask {
    display: inline-block;
    opacity: 0.6;
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    z-index: 9999;
    background-color: #fff;
}

.mask-icon-selected {
    position: absolute;
    right: 8px;
    top: 8px;
    overflow: hidden;
    text-indent: -20000px;
    width: 16px;
    height: 16px;
    background: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAgCAMAAAAsVwj+AAAAflBMVEUAAAAAAAAAMXEAAAAAAAAAGz4AGjv5+fn6+voAZ+0AaO0Aae0Bau0Ba+0FcO4Fce4Jde4YgfAdhfAkivEmi/E8mvJBnfNJofNQpfRjr/VttvZzuPZ4u/d9vveMxvin1Pqr1vqw4vu53Pu73vvg8P3r9f3y+v72+f3+///////2E4IVAAAACXRSTlMOFxkkJi4w8fOgt3JfAAAAcklEQVQoz9WPuRaCMBBFRyZBJyyiYmQHBTTz/z9IE48JLTbc8hZvAVoBm4RqtC8eXFmhW0VEF/OKrai5IEqnOftmJKO5Rj3nv9Bsfj+5dFtuzEPk1d6781+mWxHI0EEGgEd2OCEI9hB7Fv65DwKgcMDDAuhvK9uuzH50AAAAAElFTkSuQmCC')
        no-repeat;
}
</style>
